export const ID69 = () => {
    return (
        <div className="section__tab" id="opisanie_vozmozhnostey_i_printsipov_raboty">
            <div className="about-card__title">
                Описание возможностей и принципов работы
            </div>
            <p>
                Программный продукт предназначен для автоматизации процесса обработки путевых листов, учета движения
                ГСМ, учета шин и аккумуляторов и расчета заработной платы водителей на предприятиях всех сфер
                деятельности: начиная от предприятий, эксплуатирующих транспортные средства или имеющих в своем составе
                транспортные подразделения и заканчивая предприятиями, оказывающими транспортные услуги.
            </p>
            <h4>Основные возможности конфигурации</h4>
            <ul>
                <li>Выписка и обработка путевых листов;</li>
                <li>Учет остатков и движения ГСМ в баках транспортных средств (выдача, слив, списание);</li>
                <li>Расчет нормы расхода ГСМ с использованием произвольных формул, настраиваемых пользователем;</li>
                <li>Списание ГСМ в бухгалтерском учете, формирование Акта на списание ГСМ по результатам расчета нормы
                    расхода ГСМ;
                </li>
                <li>Учет результатов работы транспортных средств (пробег, тонно-километры, время работы и т.д.). Учет
                    работ ведется как по транспортным средствам, так и по заказчикам;
                </li>
                <li>Учет результатов работы водителей (отработано времени, ночные часы, время в ремонте и т.д);</li>
                <li>Расчет зарплаты водителей с учетом тарифов, которые могут быть заданы как для работника, так и для
                    транспортного средства. Алгоритм расчета и правила подстановки тарифов определяются формулами,
                    которые пользователь может изменить по своему усмотрению;
                </li>
                <li>Учет шин и аккумуляторов;</li>
                <li>Автоматическое отражение затрат на заработную плату водителей и расход ГСМ в бухгалтерском учете.
                    Возможно распределение затрат по заказчикам транспортных услуг.
                </li>
            </ul>
            <p>
                Программный продукт «1С-Рейтинг: Управление затратами на автотранспорт. Путевые листы» является
                дополнением к типовой конфигурации&nbsp;«1С:Бухгалтерия для Казахстана» редакции 3.0,&nbsp;&nbsp;системы
                программ «1С:Предприятие 8.3»
            </p>
            <p>
                <br/>
            </p>
        </div>
    )
}